export const YELLOW_COLOR = "#fec865";
export const PRIMARY_COLOR = "#429690";
export const PRIMARY_COLOR_2 = "#2A7C76";
export const COLOR_PURPLE = "#A62CE0";
export const COLOR_RED = "#e57373";
export const COLOR_BLUE = "#0C87F9";
